
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { isEmpty, filter, append as append_1, choose, empty as empty_1, findIndex, contains, tryFind, indexed, collect, length, sortBy, singleton as singleton_1, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SidebarComponentStep, ProcedureTemplateTitle, StepElement, DragStepComponent } from "./Components.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, comparePrimitives, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { LabeledValue, SectionHeader, BlockHeader } from "../../Components/Text.js";
import { useDrag, useDropGeneric } from "../../Bindings/Fable.ReactDnD.js";
import { DragProcedureStep, Msg } from "./Types.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Hamburger_Menu_1 from "../../../public/assets/icons/Hamburger_Menu_1.svg";
import { Button, TextButton } from "../../Components/Button.js";
import Arrow_Up_3 from "../../../public/assets/icons/Arrow_Up_3.svg";
import { defaultArg, bind, map as map_1, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ProcedureTemplateInformationFieldType, ProcedureTemplateHookTriggerType, ProcedureTemplateStepElementType } from "../../Shared/Procedure.js";
import { TextArea } from "../../Components/TextArea.js";
import { LabelId__get_unwrap, PropertyConfigurationId__get_unwrap, FormState__getValidation } from "../../Shared/Shared.js";
import { Input } from "../../Components/Input.js";
import { Checkbox } from "../../Components/Checkbox.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { MultiSelect, Select } from "../../Components/Select.js";
import { ToolState__ToI18nString, ToolState__ToDbString } from "../../Shared/Tool.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { tryFind as tryFind_1, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import Arrow_Left_1 from "../../../public/assets/icons/Arrow_Left_1.svg";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initCopy, initEdit, update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function Sidebar(props) {
    let elems_1;
    const patternInput = useTranslation();
    const elements = map((step) => createElement(DragStepComponent, {
        DragStep: step,
    }), props.DragSteps);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "top-0", "max-h-screen", "overflow-y-auto", "bg-white", "p-4"])], (elems_1 = [createElement(BlockHeader, {
        Text: patternInput[0]("procedure.step_type.title"),
    }), reactElement("ul", {
        children: reactApi.Children.toArray(Array.from(elements)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Dropzone(props) {
    const patternInput = useDropGeneric({
        accept: "STEP_ELEMENT",
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (step) => {
            const matchValue = step.OldPosition;
            if (matchValue == null) {
                props.Dispatch(new Msg(11, [props.StepPosition, props.StepElementPosition, step.Type]));
            }
            else {
                const oldPosition = matchValue;
                props.Dispatch(new Msg(12, [oldPosition.StepPosition, props.StepPosition, oldPosition.StepElementPosition, props.StepElementPosition]));
            }
        },
    });
    const dropData = patternInput[0];
    return reactElement("div", {
        ref: patternInput[1],
        className: join(" ", toList(delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton("flex"), delay(() => append(singleton("h-36"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("mt-4"), delay(() => append(singleton("mb-4"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => singleton("border-primary"))))))))))))))))) : singleton("h-8"))))),
    });
}

export function StepDropzone(props) {
    const patternInput = useDropGeneric({
        accept: "PROCEDURE_STEP",
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedStep) => {
            if (draggedStep.Position !== props.StepPosition) {
                props.Dispatch(new Msg(5, [draggedStep.Position, props.StepPosition]));
            }
        },
    });
    const dropData = patternInput[0];
    return reactElement("div", {
        ref: patternInput[1],
        className: join(" ", toList(delay(() => append(singleton("h-2"), delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton("h-16"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append(singleton("bg-primary"), delay(() => singleton("bg-opacity-10"))))))))))))) : empty())))))),
    });
}

export function ProcedureTemplateStep(props) {
    let elems_3;
    const patternInput = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragProcedureStep(props.Step.Position)),
        type: "PROCEDURE_STEP",
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("bg-white"), delay(() => append(singleton("rounded"), delay(() => append(singleton("shadow"), delay(() => append(singleton("p-6"), delay(() => (props.IsSelected ? append(singleton("border"), delay(() => singleton("border-primary"))) : empty()))))))))))))], ["onClick", (_arg_1) => {
        props.Dispatch(new Msg(7, [props.Step.Position]));
    }], (elems_3 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-3", "mb-4"])], (elems_1 = [reactElement("div", createObj(ofArray([["ref", patternInput[1]], ["className", join(" ", ["h-5", "w-5", "mb-4", "cursor-grab", "text-gray-400", "hover:text-gray-600"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(SectionHeader, {
            Text: props.Step.Name,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(map((element) => {
            let elems_2;
            return reactElement("div", createObj(singleton_1((elems_2 = [createElement(Dropzone, {
                Dispatch: props.Dispatch,
                StepElementPosition: element.Position,
                StepPosition: props.Step.Position,
            }), createElement(StepElement, {
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                IsSelected: props.IsSelected && equals(element.Position, props.SelectedStepElementPosition),
                StepElement: element,
                StepPosition: props.Step.Position,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
        }, sortBy((_arg_2) => (_arg_2.Position | 0), props.Step.Elements, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })), delay(() => singleton(createElement(Dropzone, {
            Dispatch: props.Dispatch,
            StepElementPosition: length(props.Step.Elements),
            StepPosition: props.Step.Position,
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function AddStepButton(props) {
    let elems, Label;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["border", "border-primary", "border-dashed", "rounded", "py-4", "flex", "justify-center"])], (elems = [createElement(TextButton, (Label = patternInput[0]("procedure.form.add_step"), {
        ComponentState: props.ComponentState,
        Icon: Arrow_Up_3(),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(4, []));
        },
        TestId: "procedure-add-step-test-id",
        Variant: "blueButton",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function MainArea(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = [createElement(ProcedureTemplateTitle, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        IsMainChecklistComponentSelected: props.IsMainChecklistComponentSelected,
        ProcedureTemplateForm: props.ProcedureTemplateForm,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = toList(delay(() => append(collect((step) => ofArray([createElement(StepDropzone, {
        Dispatch: props.Dispatch,
        StepPosition: step.Position,
    }), createElement(ProcedureTemplateStep, {
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        IsSelected: equals(step.Position, props.SelectedStepPosition),
        SelectedStepElementPosition: unwrap(props.SelectedStepElementPosition),
        Step: step,
    })]), sortBy((_arg) => (_arg.Position | 0), props.ProcedureTemplateForm.Steps, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), delay(() => singleton(createElement(StepDropzone, {
        Dispatch: props.Dispatch,
        StepPosition: length(props.ProcedureTemplateForm.Steps) - 1,
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(AddStepButton, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function InspectorStep(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "top-0", "max-h-screen", "overflow-y-auto", "bg-white", "p-4"])], (elems = [createElement(BlockHeader, {
        Text: patternInput[0]("procedure.form.step_settings"),
    }), createElement(SidebarComponentStep, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Position: props.Position,
        ProcedureTemplateStep: props.SelectedStep,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InspectorStepElement(props) {
    let elems_12, elems_11;
    const t = useTranslation()[0];
    let hasOptions;
    const matchValue = props.SelectedStepElement.Type;
    switch (matchValue.tag) {
        case 8:
        case 9:
        case 10: {
            hasOptions = true;
            break;
        }
        default:
            hasOptions = false;
    }
    const isImageType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(11, []));
    const isInspectionResultType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(12, []));
    const isDocumentType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(13, []));
    const isToolStateChangeType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(15, []));
    const fileUploadId = `image-upload-${props.Position}-${props.SelectedStepElement.Position}`;
    let stepElementTypeTitle;
    const matchValue_1 = props.SelectedStepElement.Type;
    switch (matchValue_1.tag) {
        case 2:
        case 3: {
            stepElementTypeTitle = t("procedure.step_type.number_input");
            break;
        }
        case 4: {
            stepElementTypeTitle = t("procedure.step_type.yes_no");
            break;
        }
        case 8: {
            stepElementTypeTitle = t("procedure.step_type.single_select");
            break;
        }
        case 9: {
            stepElementTypeTitle = t("procedure.step_type.multi_select");
            break;
        }
        case 10: {
            stepElementTypeTitle = t("procedure.step_type.radio_select");
            break;
        }
        case 5: {
            stepElementTypeTitle = t("procedure.step_type.date_time");
            break;
        }
        case 6: {
            stepElementTypeTitle = t("procedure.step_type.location");
            break;
        }
        case 7: {
            stepElementTypeTitle = t("procedure.step_type.signature");
            break;
        }
        case 1: {
            stepElementTypeTitle = t("procedure.step_type.text_block");
            break;
        }
        case 11: {
            stepElementTypeTitle = t("procedure.step_type.image");
            break;
        }
        case 12: {
            stepElementTypeTitle = t("procedure.step_type.inspection_result");
            break;
        }
        case 13: {
            stepElementTypeTitle = t("procedure.step_type.document_upload");
            break;
        }
        case 14: {
            stepElementTypeTitle = t("procedure.step_type.custom_field");
            break;
        }
        case 15: {
            stepElementTypeTitle = t("procedure.step_type.tool_state_change");
            break;
        }
        case 16: {
            stepElementTypeTitle = t("procedure.step_type.storage_transfer");
            break;
        }
        case 17: {
            stepElementTypeTitle = t("procedure.step_type.reminder_completion");
            break;
        }
        default:
            stepElementTypeTitle = t("procedure.step_type.text_input");
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "top-0", "max-h-screen", "overflow-y-auto", "bg-white", "p-4"])], (elems_12 = [createElement(BlockHeader, {
        Text: stepElementTypeTitle,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_11 = toList(delay(() => {
        let matchValue_2;
        return append((matchValue_2 = props.SelectedStepElement.Type, (matchValue_2.tag === 1) ? singleton(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.description"),
            OnChange: (value_2) => {
                props.Dispatch(new Msg(14, [props.Position, props.SelectedStepElement.Position, value_2]));
            },
            TestId: "",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })) : ((matchValue_2.tag === 11) ? singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("general.description"),
            OnChange: (value_3) => {
                props.Dispatch(new Msg(14, [props.Position, props.SelectedStepElement.Position, value_3]));
            },
            TestId: "",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })) : singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("general.name"),
            OnChange: (value_4) => {
                props.Dispatch(new Msg(14, [props.Position, props.SelectedStepElement.Position, value_4]));
            },
            TestId: "",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })))), delay(() => {
            let matchValue_3;
            return append((matchValue_3 = props.SelectedStepElement.Type, (matchValue_3.tag === 1) ? (empty()) : ((matchValue_3.tag === 11) ? (empty()) : ((matchValue_3.tag === 15) ? (empty()) : ((matchValue_3.tag === 16) ? (empty()) : ((matchValue_3.tag === 17) ? (empty()) : singleton(Checkbox({
                ComponentState: props.ComponentState,
                IsChecked: props.SelectedStepElement.Required,
                Label: t("general.required"),
                OnCheck: (value_5) => {
                    props.Dispatch(new Msg(15, [props.Position, props.SelectedStepElement.Position, value_5]));
                },
                TestId: "step-element-required-checkbox",
            }))))))), delay(() => {
                let elems_2;
                return append(hasOptions ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: t("procedure.step_type.options"),
                })), delay(() => append(map((tupledArg) => {
                    let elems_1, elems;
                    const index = tupledArg[0] | 0;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-2", "items-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems = [createElement(Input, {
                        ComponentState: props.ComponentState,
                        OnChange: (value_12) => {
                            props.Dispatch(new Msg(18, [props.Position, props.SelectedStepElement.Position, index, value_12]));
                        },
                        TestId: "",
                        Value: tupledArg[1],
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("button", {
                        className: join(" ", ["text-red", "hover:text-red", "p-1", "text-sm"]),
                        onClick: (_arg) => {
                            props.Dispatch(new Msg(17, [props.Position, props.SelectedStepElement.Position, index]));
                        },
                        children: "✕",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
                }, indexed(props.SelectedStepElement.Options)), delay(() => singleton(createElement(TextButton, {
                    ComponentState: props.ComponentState,
                    Label: t("procedure.step_type.add_option"),
                    OnClick: () => {
                        props.Dispatch(new Msg(16, [props.Position, props.SelectedStepElement.Position, ""]));
                    },
                    TestId: "add-option-button",
                    Variant: "blueButton",
                })))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => {
                    let elems_7, elems_5, elems_6;
                    return append(isImageType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_7 = [reactElement("label", {
                        className: join(" ", ["text-sm", "font-bold"]),
                        children: t("procedure.step_type.images"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_5 = toList(delay(() => map((tupledArg_1) => {
                        let elems_4, elems_3;
                        return reactElement("div", createObj(ofArray([["className", join(" ", ["relative"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "top-1", "right-1", "h-5", "w-5", "p-1", "rounded-full", "text-red", "bg-white", "cursor-pointer", "shadow"])], ["onClick", (e) => {
                            e.preventDefault();
                            props.Dispatch(new Msg(21, [props.Position, props.SelectedStepElement.Position, tupledArg_1[0]]));
                        }], (elems_3 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("img", {
                            className: join(" ", ["shadow", "rounded", "border", "w-24", "h-20", "object-cover"]),
                            src: tupledArg_1[1],
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                    }, indexed(props.SelectedStepElement.Options)))), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(singleton_1((elems_6 = [createElement(TextButton, {
                        ComponentState: props.ComponentState,
                        Label: t("procedure.step_type.upload_image"),
                        OnClick: () => {
                            const element = document.getElementById(fileUploadId);
                            element.click();
                        },
                        TestId: "upload-image-button",
                        Variant: "blueButton",
                    }), reactElement("input", {
                        id: fileUploadId,
                        className: join(" ", ["hidden"]),
                        type: "file",
                        accept: ".jpg, .jpeg, .png",
                        onChange: (ev) => {
                            const files = ev.target.files;
                            if (!(files == null) && (files.length > 0)) {
                                props.Dispatch(new Msg(19, [props.Position, props.SelectedStepElement.Position, files.item(0)]));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_6))]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
                        let elems_8, Label_7, Options;
                        return append(isInspectionResultType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_8 = [createElement(Select, (Label_7 = t("procedure.step_type.inspection_template"), (Options = map((template) => ({
                            label: template.Name,
                            value: template.Id,
                        }), props.AvailableInspectionTemplates), {
                            ComponentState: props.ComponentState,
                            IsClearable: true,
                            Label: unwrap(Label_7),
                            NoOptionsMessage: t("procedure.step_type.no_inspection_templates"),
                            OnChange: (selected) => {
                                props.Dispatch(new Msg(22, [props.Position, props.SelectedStepElement.Position, map_1((s) => s.value, selected)]));
                            },
                            Options: Options,
                            PlaceholderKey: "general.select",
                            TestId: "inspection-template-select",
                            Value: unwrap(bind((id) => map_1((t_2) => ({
                                label: t_2.Name,
                                value: t_2.Id,
                            }), tryFind((t_1) => (t_1.Id === id), props.AvailableInspectionTemplates)), props.SelectedStepElement.InspectionTemplateId)),
                        })))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty(), delay(() => {
                            let elems_9;
                            return append(isToolStateChangeType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_9 = toList(delay(() => append(singleton(reactElement("label", {
                                className: join(" ", ["text-sm", "font-bold"]),
                                children: t("procedure.tool_state_change.allowed_states"),
                            })), delay(() => map((state) => {
                                const stateString = ToolState__ToDbString(state);
                                const isChecked = contains(stateString, props.SelectedStepElement.Options, {
                                    Equals: (x, y) => (x === y),
                                    GetHashCode: (x) => (stringHash(x) | 0),
                                });
                                return Checkbox({
                                    ComponentState: props.ComponentState,
                                    IsChecked: isChecked,
                                    Label: t(ToolState__ToI18nString(state)),
                                    OnCheck: (newChecked) => {
                                        if (newChecked && !isChecked) {
                                            props.Dispatch(new Msg(16, [props.Position, props.SelectedStepElement.Position, stateString]));
                                        }
                                        else if (!newChecked && isChecked) {
                                            props.Dispatch(new Msg(17, [props.Position, props.SelectedStepElement.Position, findIndex((o) => (o === stateString), props.SelectedStepElement.Options)]));
                                        }
                                    },
                                    TestId: concat("tool-state-change-allowed-", ...stateString),
                                });
                            }, ofArray(["active", "inMaintenance", "retired", "lost"])))))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                                let elems_10, Label_9, Options_1;
                                return append(equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(14, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_10 = [createElement(Select, (Label_9 = t("procedure.step_type.property_configuration"), (Options_1 = map((pc) => ({
                                    label: pc.Name,
                                    value: PropertyConfigurationId__get_unwrap(pc.Id),
                                }), props.PropertyConfigurations), {
                                    ComponentState: props.ComponentState,
                                    IsClearable: true,
                                    Label: unwrap(Label_9),
                                    NoOptionsMessage: t("procedure.step_type.no_property_configurations"),
                                    OnChange: (selected_1) => {
                                        props.Dispatch(new Msg(23, [props.Position, props.SelectedStepElement.Position, map_1((s_1) => s_1.value, selected_1)]));
                                    },
                                    Options: Options_1,
                                    PlaceholderKey: "general.select",
                                    TestId: "property-configuration-select",
                                    Value: unwrap(bind((id_1) => map_1((pc_2) => ({
                                        label: pc_2.Name,
                                        value: PropertyConfigurationId__get_unwrap(pc_2.Id),
                                    }), tryFind((pc_1) => (PropertyConfigurationId__get_unwrap(pc_1.Id) === id_1), props.PropertyConfigurations)), props.SelectedStepElement.PropertyConfigurationId)),
                                })))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty(), delay(() => singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: t("general.delete"),
                                    OnClick: () => {
                                        props.Dispatch(new Msg(13, [props.Position, props.SelectedStepElement.Position]));
                                    },
                                    TestId: "remove-step-button-test-id",
                                    Variant: "redButton",
                                }))));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function getTriggerTypeLabel(t, triggerType) {
    switch (triggerType.tag) {
        case 1:
            return t("procedure.hooks.trigger_type.assignment_sender");
        case 2:
            return t("procedure.hooks.trigger_type.return_receiver");
        case 3:
            return t("procedure.hooks.trigger_type.return_sender");
        case 4:
            return t("procedure.hooks.trigger_type.handover");
        case 5:
            return t("procedure.hooks.trigger_type.reservation");
        case 6:
            return t("procedure.hooks.trigger_type.status_change");
        case 7:
            return t("procedure.hooks.trigger_type.manual_storage_manager");
        case 8:
            return t("procedure.hooks.trigger_type.manual_user");
        default:
            return t("procedure.hooks.trigger_type.assignment_receiver");
    }
}

export function HookConfiguration(props) {
    let elems_4, elems_1, elems, elems_3;
    const t = useTranslation()[0];
    const triggerTypeLabel = getTriggerTypeLabel(t, props.TriggerType);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["border", "rounded", "p-4", "mb-3", "bg-gray-50"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-3"])], (elems_1 = [reactElement("span", {
        className: join(" ", ["font-medium", "text-primary"]),
        children: triggerTypeLabel,
    }), reactElement("button", createObj(ofArray([["className", join(" ", ["text-gray-400", "hover:text-red", "p-1", "rounded", "hover:bg-red", "hover:bg-opacity-10"])], ["onClick", (_arg) => {
        props.Dispatch(new Msg(27, [props.TriggerType]));
    }], ["title", t("general.delete")], (elems = [reactElement("span", {
        children: "✕",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_3 = toList(delay(() => append((!equals(props.TriggerType, new ProcedureTemplateHookTriggerType(7, [])) && !equals(props.TriggerType, new ProcedureTemplateHookTriggerType(8, []))) ? singleton(Checkbox({
        ComponentState: props.ComponentState,
        IsChecked: props.HookState.IsMandatory,
        Label: t("procedure.hooks.is_mandatory"),
        OnCheck: (checked$0027) => {
            props.Dispatch(new Msg(28, [props.TriggerType, checked$0027]));
        },
        TestId: `hook-mandatory-${props.TriggerType}`,
    })) : empty(), delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2"])], (elems_2 = [createElement(MultiSelect, {
            ComponentState: props.ComponentState,
            IsClearable: true,
            Label: t("procedure.hooks.labels"),
            NoOptionsMessage: "procedure.hooks.no_labels",
            OnChange: (selectedOptions) => {
                props.Dispatch(new Msg(31, [props.TriggerType, defaultArg(map_1((arg) => ofArray(map_2((opt) => parse(opt.value), arg)), selectedOptions), empty_1())]));
            },
            Options: props.AvailableLabels,
            PlaceholderKey: "general.select",
            TestId: `hook-labels-${props.TriggerType}`,
            Value: choose((labelId) => tryFind((opt_1) => (opt_1.value === labelId), props.AvailableLabels), props.HookState.LabelIds),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => singleton(reactElement("p", {
            className: join(" ", ["text-xs", "text-gray-500", "mt-1"]),
            children: t("procedure.hooks.labels_info"),
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function AddHookSelect(props) {
    let elems;
    const patternInput = useTranslation();
    const options = map((triggerType) => ({
        label: getTriggerTypeLabel(patternInput[0], triggerType),
        value: triggerType,
    }), props.AvailableTriggerTypes);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems = [createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        NoOptionsMessage: "procedure.hooks.no_more_hooks",
        OnChange: (selected) => {
            if (selected == null) {
            }
            else {
                props.Dispatch(new Msg(27, [selected.value]));
            }
        },
        Options: options,
        PlaceholderKey: "procedure.hooks.add_hook",
        TestId: "add-hook-select",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InspectorDefinition(props) {
    let elems_10;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "top-0", "max-h-screen", "overflow-y-auto", "bg-white", "p-4"])], (elems_10 = toList(delay(() => append(singleton(createElement(BlockHeader, {
        Text: t("procedure.form.basic_settings"),
    })), delay(() => {
        let elems_4;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-6"])], (elems_4 = toList(delay(() => append((props.ProcedureTemplateForm.State.tag === 0) ? append(singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("procedure.form.procedure_template_name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(1, [arg]));
            },
            TestId: "",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "procedure_template_name")),
            Value: props.ProcedureTemplateForm.Name,
        })), delay(() => {
            let elems;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems = [createElement(TextArea, {
                ComponentState: props.ComponentState,
                Label: t("procedure.form.procedure_template_description"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(2, [arg_1]));
                },
                TestId: "",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "procedure_template_description")),
                Value: props.ProcedureTemplateForm.Description,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        })) : append(singleton(LabeledValue({
            Label: t("procedure.form.procedure_template_name"),
            Value: props.ProcedureTemplateForm.Name,
        })), delay(() => singleton(LabeledValue({
            Label: t("procedure.form.procedure_template_description"),
            Value: props.ProcedureTemplateForm.Description,
        })))), delay(() => {
            let elems_3;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_3 = toList(delay(() => append(singleton(reactElement("label", {
                className: join(" ", ["block", "text-sm", "font-bold", "mb-2"]),
                children: t("procedure.form.state"),
            })), delay(() => {
                let matchValue_2;
                return append(singleton(reactElement("span", {
                    className: join(" ", toList(delay(() => append(singleton("py-1"), delay(() => append(singleton("rounded"), delay(() => append(singleton("text-sm"), delay(() => {
                        const matchValue_1 = props.ProcedureTemplateForm.State;
                        return (matchValue_1.tag === 2) ? append(singleton("bg-green"), delay(() => append(singleton("bg-opacity-20"), delay(() => singleton("text-green"))))) : ((matchValue_1.tag === 1) ? append(singleton("bg-orange"), delay(() => append(singleton("bg-opacity-20"), delay(() => singleton("text-orange"))))) : append(singleton("bg-gray-200"), delay(() => singleton("text-gray-700"))));
                    }))))))))),
                    children: (matchValue_2 = props.ProcedureTemplateForm.State, (matchValue_2.tag === 2) ? t("procedure.state.released") : ((matchValue_2.tag === 1) ? t("procedure.state.archived") : t("procedure.state.draft"))),
                })), delay(() => {
                    let elems_1, elems_2;
                    const matchValue_4 = props.ProcedureTemplateForm.State;
                    let matchResult;
                    if (props.ProcedureTemplateId != null) {
                        switch (matchValue_4.tag) {
                            case 0: {
                                matchResult = 0;
                                break;
                            }
                            case 2: {
                                matchResult = 1;
                                break;
                            }
                            default:
                                matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-3"])], (elems_1 = [createElement(TextButton, {
                                ComponentState: props.ComponentState,
                                Label: t("procedure.action.release"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(34, []));
                                },
                                TestId: "release-procedure-template",
                                Variant: "blueButton",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                        case 1:
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-3"])], (elems_2 = [createElement(TextButton, {
                                ComponentState: props.ComponentState,
                                Label: t("procedure.action.archive"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(40, []));
                                },
                                TestId: "archive-procedure-template",
                                Variant: "redButton",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                        default: {
                            return empty();
                        }
                    }
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            const getInformationFieldLabel = (fieldType) => {
                switch (fieldType.tag) {
                    case 1:
                        return t("procedure.information_fields.manufacturer");
                    case 2:
                        return t("procedure.information_fields.model");
                    case 3:
                        return t("procedure.information_fields.serial_number");
                    case 4:
                        return t("procedure.information_fields.inventory_number");
                    case 5:
                        return t("procedure.information_fields.comment");
                    case 6:
                        return t("procedure.information_fields.storage_name");
                    case 7:
                        return t("procedure.information_fields.storage_space");
                    case 8:
                        return defaultArg(map_1((_arg_2) => _arg_2.Name, tryFind((pc) => (PropertyConfigurationId__get_unwrap(pc.Id) === fieldType.fields[0]), props.PropertyConfigurations)), t("procedure.information_fields.custom_field"));
                    default:
                        return t("procedure.information_fields.display_name");
                }
            };
            return append(singleton(createElement(BlockHeader, {
                Text: t("procedure.information_fields.title"),
            })), delay(() => append(singleton(reactElement("p", {
                className: join(" ", ["text-sm", "text-gray-600", "mb-4"]),
                children: t("procedure.information_fields.description"),
            })), delay(() => {
                let elems_7;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-6"])], (elems_7 = toList(delay(() => append(map((field) => {
                    let elems_5;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "border", "rounded", "p-3", "mb-2", "bg-gray-50"])], (elems_5 = [reactElement("span", {
                        className: join(" ", ["text-sm"]),
                        children: getInformationFieldLabel(field.FieldType),
                    }), reactElement("button", {
                        className: join(" ", ["text-red", "hover:text-red", "p-1", "text-sm"]),
                        onClick: (_arg_4) => {
                            props.Dispatch(new Msg(25, [field.Position]));
                        },
                        children: "✕",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
                }, sortBy((_arg_3) => (_arg_3.Position | 0), props.ProcedureTemplateForm.InformationFields, {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                })), delay(() => {
                    let elems_6;
                    if (props.ProcedureTemplateForm.State.tag === 0) {
                        const allFieldTypes = append_1(ofArray([new ProcedureTemplateInformationFieldType(0, []), new ProcedureTemplateInformationFieldType(1, []), new ProcedureTemplateInformationFieldType(2, []), new ProcedureTemplateInformationFieldType(3, []), new ProcedureTemplateInformationFieldType(4, []), new ProcedureTemplateInformationFieldType(5, []), new ProcedureTemplateInformationFieldType(6, []), new ProcedureTemplateInformationFieldType(7, [])]), map((pc_1) => (new ProcedureTemplateInformationFieldType(8, [PropertyConfigurationId__get_unwrap(pc_1.Id)])), props.PropertyConfigurations));
                        const usedFieldTypeKeys = ofList(map((f) => {
                            const matchValue_7 = f.FieldType;
                            if (matchValue_7.tag === 8) {
                                return concat("custom_", ...matchValue_7.fields[0]);
                            }
                            else {
                                return toString(matchValue_7);
                            }
                        }, props.ProcedureTemplateForm.InformationFields), {
                            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                        });
                        const availableFieldTypes = filter((ft_2) => {
                            let ft_1;
                            return !FSharpSet__Contains(usedFieldTypeKeys, (ft_1 = ft_2, (ft_1.tag === 8) ? concat("custom_", ...ft_1.fields[0]) : toString(ft_1)));
                        }, allFieldTypes);
                        if (!isEmpty(availableFieldTypes)) {
                            const options = map((ft_3) => ({
                                label: getInformationFieldLabel(ft_3),
                                value: ft_3,
                            }), availableFieldTypes);
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2"])], (elems_6 = [createElement(Select, {
                                ComponentState: props.ComponentState,
                                IsClearable: false,
                                NoOptionsMessage: "procedure.information_fields.no_more_fields",
                                OnChange: (selected) => {
                                    if (selected == null) {
                                    }
                                    else {
                                        props.Dispatch(new Msg(24, [selected.value]));
                                    }
                                },
                                Options: options,
                                PlaceholderKey: "procedure.information_fields.add_field",
                                TestId: "add-information-field-select",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                        }
                        else {
                            return empty();
                        }
                    }
                    else {
                        return empty();
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => append(singleton(createElement(BlockHeader, {
                    Text: t("procedure.hooks.title"),
                })), delay(() => append(singleton(reactElement("p", {
                    className: join(" ", ["text-sm", "text-gray-600", "mb-4"]),
                    children: t("procedure.hooks.description"),
                })), delay(() => {
                    let elems_8;
                    const enabledHooks = filter((tupledArg) => tupledArg[1].IsEnabled, toList_1(props.Hooks));
                    const availableTriggerTypes = filter((triggerType) => defaultArg(map_1((h) => !h.IsEnabled, tryFind_1(triggerType, props.Hooks)), true), ofArray([new ProcedureTemplateHookTriggerType(1, []), new ProcedureTemplateHookTriggerType(0, []), new ProcedureTemplateHookTriggerType(3, []), new ProcedureTemplateHookTriggerType(2, []), new ProcedureTemplateHookTriggerType(7, []), new ProcedureTemplateHookTriggerType(8, [])]));
                    return append(singleton(reactElement("div", createObj(singleton_1((elems_8 = toList(delay(() => map((tupledArg_1) => createElement(HookConfiguration, {
                        AvailableLabels: props.AvailableLabels,
                        ComponentState: props.ComponentState,
                        Dispatch: props.Dispatch,
                        HookState: tupledArg_1[1],
                        TriggerType: tupledArg_1[0],
                    }), enabledHooks))), ["children", reactApi.Children.toArray(Array.from(elems_8))]))))), delay(() => append(!isEmpty(availableTriggerTypes) ? singleton(createElement(AddHookSelect, {
                        AvailableTriggerTypes: availableTriggerTypes,
                        ComponentState: props.ComponentState,
                        Dispatch: props.Dispatch,
                    })) : empty(), delay(() => {
                        let elems_9;
                        if (props.ProcedureTemplateForm.State.tag === 2) {
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "justify-end"])], (elems_9 = [createElement(Button, {
                                ComponentState: props.ComponentState,
                                Label: t("procedure.hooks.save_hooks"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(38, []));
                                },
                                TestId: "save-hooks-button",
                                Variant: "primary",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                        }
                        else {
                            return empty();
                        }
                    }))));
                }))))));
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

function View(props) {
    let elems_3, elems_1, Label, elems, elems_2, Title, Title_1, Title_2;
    const t = useTranslation()[0];
    const state = props.State;
    const dispatch = props.Dispatch;
    const availableLabels = map((label) => ({
        label: label.Name,
        value: LabelId__get_unwrap(label.Id),
    }), state.AvailableLabels);
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-4"])], (elems_1 = [createElement(TextButton, (Label = t("general.overview"), {
        ComponentState: "enabled",
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: () => {
            RouterModule_nav(ofArray(["procedure-templates"]), 1, 1);
        },
        TestId: "back-to-overview-button",
        Variant: "default",
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3"])], (elems = toList(delay(() => append((state.FormKind.tag === 1) ? ((state.ProcedureTemplateId != null) ? singleton(createElement(TextButton, {
        ComponentState: componentState,
        Label: t("general.duplicate"),
        OnClick: () => {
            dispatch(new Msg(44, []));
        },
        TestId: "duplicate-procedure-template-button",
        Variant: "default",
    })) : (empty())) : (empty()), delay(() => {
        if (props.ProcedureTemplateForm.State.tag === 0) {
            return singleton(createElement(Button, {
                ComponentState: componentState,
                Label: t("general.save"),
                OnClick: () => {
                    dispatch(new Msg(32, []));
                },
                TestId: "save-button-checklist-definition-test-id",
                Variant: "primary",
            }));
        }
        else {
            return empty();
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[20rem_1fr_20rem]", "gap-5"])], (elems_2 = toList(delay(() => append(singleton(createElement(Sidebar, {
        DragSteps: state.DragSteps,
    })), delay(() => append(singleton(createElement(MainArea, {
        ComponentState: componentState,
        Dispatch: props.Dispatch,
        FormState: state.FormState,
        IsMainChecklistComponentSelected: state.IsMainChecklistComponentSelected,
        ProcedureTemplateForm: props.ProcedureTemplateForm,
        SelectedStepElementPosition: unwrap(state.SelectedStepElementPosition),
        SelectedStepPosition: unwrap(state.SelectedStepPosition),
    })), delay(() => {
        const matchValue_4 = state.SelectedStepPosition;
        const matchValue_5 = state.SelectedStepElementPosition;
        const matchValue_6 = state.IsMainChecklistComponentSelected;
        let matchResult, selectedStepPosition, selectedStepElementPosition, selectedStepPosition_1;
        if (matchValue_4 != null) {
            if (matchValue_5 != null) {
                if (matchValue_6) {
                    matchResult = 2;
                }
                else {
                    matchResult = 1;
                    selectedStepElementPosition = matchValue_5;
                    selectedStepPosition_1 = matchValue_4;
                }
            }
            else if (matchValue_6) {
                matchResult = 2;
            }
            else {
                matchResult = 0;
                selectedStepPosition = matchValue_4;
            }
        }
        else if (matchValue_6) {
            matchResult = 2;
        }
        else {
            matchResult = 3;
        }
        switch (matchResult) {
            case 0: {
                const matchValue_8 = tryFind((step) => (step.Position === selectedStepPosition), props.ProcedureTemplateForm.Steps);
                if (matchValue_8 == null) {
                    return empty();
                }
                else {
                    return singleton(createElement(InspectorStep, {
                        ComponentState: componentState,
                        Dispatch: dispatch,
                        FormState: state.FormState,
                        Position: selectedStepPosition,
                        SelectedStep: matchValue_8,
                    }));
                }
            }
            case 1: {
                const matchValue_9 = tryFind((step_3) => (step_3.Position === selectedStepPosition_1), props.ProcedureTemplateForm.Steps);
                if (matchValue_9 == null) {
                    return empty();
                }
                else {
                    const matchValue_10 = tryFind((stepElement) => (stepElement.Position === selectedStepElementPosition), matchValue_9.Elements);
                    if (matchValue_10 == null) {
                        return empty();
                    }
                    else {
                        return singleton(createElement(InspectorStepElement, {
                            AvailableInspectionTemplates: state.AvailableInspectionTemplates,
                            ComponentState: componentState,
                            Dispatch: dispatch,
                            FormState: state.FormState,
                            Position: selectedStepPosition_1,
                            PropertyConfigurations: state.PropertyConfigurations,
                            SelectedStepElement: matchValue_10,
                        }));
                    }
                }
            }
            case 2:
                return singleton(createElement(InspectorDefinition, {
                    AvailableLabels: availableLabels,
                    ComponentState: componentState,
                    Dispatch: dispatch,
                    FormState: state.FormState,
                    Hooks: state.Hooks,
                    ProcedureTemplateForm: props.ProcedureTemplateForm,
                    ProcedureTemplateId: unwrap(state.ProcedureTemplateId),
                    PropertyConfigurations: state.PropertyConfigurations,
                }));
            default: {
                return empty();
            }
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(ConfirmationDialog, (Title = t("procedure.action.release"), {
        Description: t("procedure.action.release_confirmation"),
        IsOpen: state.IsReleaseDialogOpen,
        OnClose: () => {
            dispatch(new Msg(36, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(35, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("procedure.action.archive"), {
        Description: t("procedure.action.archive_confirmation"),
        IsOpen: state.IsArchiveDialogOpen,
        OnClose: () => {
            dispatch(new Msg(42, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(41, []));
        },
        Title: Title_1,
    })), createElement(ConfirmationDialog, (Title_2 = t("procedure.action.duplicate"), {
        Description: t("procedure.action.duplicate_confirmation"),
        IsOpen: state.IsDuplicateDialogOpen,
        OnClose: () => {
            dispatch(new Msg(46, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(45, []));
        },
        Title: Title_2,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function NewView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

export function EditView(props) {
    let patternInput;
    const init = initEdit(props.ProcedureTemplateId);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

export function CopyView(props) {
    let patternInput;
    const init = initCopy(props.ProcedureTemplateId);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

